import { useMemo } from "react";

// Gedeeld telefoonveld met landcode-selector (JOH. huisstijl).
// Standaard Nederland (+31). De waarde naar boven is altijd het volledige nummer, bijv. "+31612345678".
export const COUNTRY_CODES = [
  { code: "+31", iso: "NL", name: "Nederland" },
  { code: "+32", iso: "BE", name: "België" },
  { code: "+49", iso: "DE", name: "Duitsland" },
  { code: "+44", iso: "UK", name: "Verenigd Koninkrijk" },
  { code: "+33", iso: "FR", name: "Frankrijk" },
  { code: "+34", iso: "ES", name: "Spanje" },
  { code: "+39", iso: "IT", name: "Italië" },
  { code: "+351", iso: "PT", name: "Portugal" },
  { code: "+48", iso: "PL", name: "Polen" },
  { code: "+90", iso: "TR", name: "Turkije" },
  { code: "+212", iso: "MA", name: "Marokko" },
  { code: "+1", iso: "US", name: "VS / Canada" },
];

// Splits een volledig nummer in (landcode, nationaal nummer); onbekende code → +31
export function splitPhone(value) {
  const v = (value || "").trim();
  const sorted = [...COUNTRY_CODES].sort((a, b) => b.code.length - a.code.length);
  for (const c of sorted) {
    if (v.startsWith(c.code)) return { code: c.code, number: v.slice(c.code.length) };
  }
  return { code: "+31", number: v.replace(/^\+/, "") };
}

export function PhoneField({ value, onChange, error, dark = false, testid = "phone", label }) {
  const { code, number } = useMemo(() => splitPhone(value), [value]);
  const emit = (c, n) => onChange(`${c}${n.replace(/[\s-]/g, "")}`);
  return (
    <div data-testid={`${testid}-wrap`}>
      {label && <label className={`chip ${dark ? "text-[#A3A3A3]" : "text-[#4A4A4A]"}`}>{label}</label>}
      <div className={`flex items-center gap-3 border-b transition-colors ${dark ? "border-white/25 focus-within:border-[#F5F3F0]" : "border-[#0A0A0A]/20 focus-within:border-[#0A0A0A]"}`}>
        <select
          value={code}
          onChange={(e) => emit(e.target.value, number)}
          className={`bg-transparent py-3.5 text-[15px] outline-none cursor-pointer shrink-0 ${dark ? "text-[#F5F3F0]" : "text-[#0A0A0A]"}`}
          style={{ fontFamily: "'Manrope', sans-serif" }}
          data-testid={`${testid}-country`}
          aria-label="Landcode"
        >
          {COUNTRY_CODES.map((c) => (
            <option key={c.code} value={c.code} className="bg-[#0A0A0A] text-[#F5F3F0]">
              {c.iso} {c.code}
            </option>
          ))}
        </select>
        <span className={`w-px h-5 ${dark ? "bg-white/25" : "bg-[#0A0A0A]/20"}`} />
        <input
          value={number}
          onChange={(e) => emit(code, e.target.value)}
          className={`flex-1 bg-transparent border-0 outline-none py-3.5 text-[15px] ${dark ? "text-[#F5F3F0] placeholder:text-[#F5F3F0]/40" : "text-[#0A0A0A] placeholder:text-[#9A968E]"}`}
          style={{ fontFamily: "'Manrope', sans-serif" }}
          placeholder="6 12345678"
          inputMode="tel"
          data-testid={testid}
        />
      </div>
      {error && <div className={`chip mt-2 ${dark ? "text-red-400" : "text-red-600"}`} data-testid={`${testid}-error`}>{error}</div>}
    </div>
  );
}
